<div class="ui-badge {{ getBadgeSize() }}" [ngClass]="{'disabled': isDisabled(), 'g-loader-s':isLoading(), 'responsive': isResponsive()}">
    @if (badgeConfig().variant === 'bold-text') {
        @if (badgeConfig()?.icon) {
            <app-icon class="icon" [svgIcon]="badgeConfig()?.icon"></app-icon>
        }
        @if (badgeConfig()?.label) {
            <span class="bold-text">{{ badgeConfig()?.label }}</span>
        }
    }
</div>